import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { TimerLineDirective } from '../timer-line-directive';

@Component({
  selector: 'wilson-nz-message-timer-line',
  imports: [TimerLineDirective],
  templateUrl: './nz-message-timer-line.component.html',
  styleUrl: './nz-message-timer-line.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NzMessageTimerLineComponent {
  @Input() duration = 3000;
  @Input() showIcon = true;
}
